<template>
    <ve-table
        :columnHiddenOption="columnHiddenOption"
        :table-data="data"
        :cell-style-option="cellStyleOption"
        :cellSelectionOption="cellSelectionOption"
        :row-style-option="rowStyleOption"
        :border-around="false"
        :border-x="true"
        :border-y="false"
        :sort-option="sortOption"
        :virtual-scroll-option="virtualScrollOption"
        row-key-field-name="rowKey"
        class="reporting-table modal-table"
        v-bind="$attrs"
        fixed-header
    />
</template>
<script>
    import tableHelper from 'components/user/organizationreport/tables/helpers/table-helper'
    export default {
        name: 'virtual-scroll-table',
        mixins: [ tableHelper ],
        props: {
            data: {
                type: Array
            },
            columnHiddenOption: {
                type: Object,
                default: () => ({})
            },
        },
        data () {
            return {
                virtualScrollOption: {
                    enable: true,
                    bufferScale: 10
                },
                rowStyleOption: {
                    stripe: true
                }
            }
        },
    }
</script>

<style lang="scss">
    .reporting-table.modal-table {
        .table-header-cell {
            text-transform: none;
            height: 39px;
        }

        .ve-table {
            .ve-table-content {
                border-top: none;
            }

            tr.ve-table-body-tr {
                &:hover {
                    cursor: default;
                }
            }
        }
    }
</style>
